import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { Schemas } from 'vscode/vscode/vs/base/common/network';
import { registerEditorContribution } from 'vscode/vscode/vs/editor/browser/editorExtensions';
import { ICommandService } from 'vscode/vscode/vs/platform/commands/common/commands.service';
import { IConfigurationService } from 'vscode/vscode/vs/platform/configuration/common/configuration.service';
import { IHoverService } from 'vscode/vscode/vs/platform/hover/browser/hover.service';
import { IKeybindingService } from 'vscode/vscode/vs/platform/keybinding/common/keybinding.service';
import { IProductService } from 'vscode/vscode/vs/platform/product/common/productService.service';
import { ITelemetryService } from 'vscode/vscode/vs/platform/telemetry/common/telemetry.service';
import { EmptyTextEditorHintContribution } from '../../../../codeEditor/browser/emptyTextEditorHint/emptyTextEditorHint.js';
import { IInlineChatSessionService } from 'vscode/vscode/vs/workbench/contrib/inlineChat/browser/inlineChatSessionService.service';
import { IInlineChatService } from 'vscode/vscode/vs/workbench/contrib/inlineChat/common/inlineChat.service';
import { getNotebookEditorFromEditorPane } from 'vscode/vscode/vs/workbench/contrib/notebook/browser/notebookBrowser';
import { IEditorGroupsService } from 'vscode/vscode/vs/workbench/services/editor/common/editorGroupsService.service';
import { IEditorService } from 'vscode/vscode/vs/workbench/services/editor/common/editorService.service';

let EmptyCellEditorHintContribution = class EmptyCellEditorHintContribution extends EmptyTextEditorHintContribution {
    static { this.CONTRIB_ID = 'notebook.editor.contrib.emptyCellEditorHint'; }
    constructor(editor, _editorService, editorGroupsService, commandService, configurationService, hoverService, keybindingService, inlineChatSessionService, inlineChatService, telemetryService, productService) {
        super(editor, editorGroupsService, commandService, configurationService, hoverService, keybindingService, inlineChatSessionService, inlineChatService, telemetryService, productService);
        this._editorService = _editorService;
        const activeEditor = getNotebookEditorFromEditorPane(this._editorService.activeEditorPane);
        if (!activeEditor) {
            return;
        }
        this.toDispose.push(activeEditor.onDidChangeActiveCell(() => this.update()));
    }
    _getOptions() {
        return { clickable: false };
    }
    _shouldRenderHint() {
        const shouldRenderHint = super._shouldRenderHint();
        if (!shouldRenderHint) {
            return false;
        }
        const model = this.editor.getModel();
        if (!model) {
            return false;
        }
        const isNotebookCell = model?.uri.scheme === Schemas.vscodeNotebookCell;
        if (!isNotebookCell) {
            return false;
        }
        const activeEditor = getNotebookEditorFromEditorPane(this._editorService.activeEditorPane);
        if (!activeEditor) {
            return false;
        }
        const activeCell = activeEditor.getActiveCell();
        if (activeCell?.uri.fragment !== model.uri.fragment) {
            return false;
        }
        return true;
    }
};
EmptyCellEditorHintContribution = ( __decorate([
    ( __param(1, IEditorService)),
    ( __param(2, IEditorGroupsService)),
    ( __param(3, ICommandService)),
    ( __param(4, IConfigurationService)),
    ( __param(5, IHoverService)),
    ( __param(6, IKeybindingService)),
    ( __param(7, IInlineChatSessionService)),
    ( __param(8, IInlineChatService)),
    ( __param(9, ITelemetryService)),
    ( __param(10, IProductService))
], EmptyCellEditorHintContribution));
registerEditorContribution(EmptyCellEditorHintContribution.CONTRIB_ID, EmptyCellEditorHintContribution, 0 );

export { EmptyCellEditorHintContribution };
